module.exports = __webpack_public_path__ + "img/card.6fcf8f7c.svg";